let tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

class Video {
    constructor (videoBlockId, isOldSkl) {
        this.videoBlockEl = document.querySelector(videoBlockId);
        this.videoCounter = this.videoBlockEl.getAttribute('data-video-counter');
        this.videoPosterSrc = this.videoBlockEl.getAttribute('data-thumbnail') || '';
        
        if (isOldSkl) {
            const videoLink = this.videoBlockEl.querySelector('iframe').getAttribute('src');
            this.videoID = this.YouTubeGetID(videoLink);
            this.videoBlockEl.innerHTML = '';
        } else {
            this.videoLink = this.videoBlockEl.getAttribute('data-video-link');
            this.videoID = this.YouTubeGetID(this.videoLink);
        }
        this.createDOM();
    }

    createDOM () {
        let posterSrc = '';
        if (this.videoPosterSrc.length) {
            posterSrc = this.videoPosterSrc;
        } else {
            var posterObj = new Image();
            posterObj.src = `https://img.youtube.com/vi/${this.videoID}/maxresdefault.jpg`;
            posterObj.onload = () => {
                const isExist = this.checkThumbnail(this.width);
                posterSrc = `https://img.youtube.com/vi/${this.videoID}/maxresdefault.jpg`;
            }
        }
        // const posterSrc = this.videoPosterSrc.length ? this.videoPosterSrc : `https://img.youtube.com/vi/${this.videoID}/maxresdefault.jpg`;
        const vIframe = document.createElement('iframe');
        vIframe.setAttribute('src', `https://www.youtube.com/embed/${this.videoID}?enablejsapi=1&html5=1&rel=0&cc_load_policy=1&cc_lang_pref=en`);
        vIframe.id = `video-element-${this.videoCounter}`;
        vIframe.width = '560';
        vIframe.height = '315';
        vIframe.frameBorder = '0';
        vIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        vIframe.setAttribute('allowfullscreen', '');

        const videoPlayIconEl = document.createElement('a');
        videoPlayIconEl.href = '#'; 
        videoPlayIconEl.id = `start-video-${this.videoCounter}`;
        videoPlayIconEl.classList.add('yt-player-trigger-play'); // ie only work for single value
        videoPlayIconEl.classList.add('video-player-icon');

        const videoOverlayEl = document.createElement('div');
        videoOverlayEl.classList.add('video-player-overlay');
        videoOverlayEl.style.backgroundImage = posterSrc ? `url(${posterSrc})` : 'none';
        videoOverlayEl.appendChild(videoPlayIconEl);

        this.videoBlockEl.appendChild(vIframe);
        this.videoBlockEl.appendChild(videoOverlayEl);
    }

    init () {
        this.playOverlay = this.videoBlockEl.querySelector('.video-player-overlay');
        this.playButton = this.playOverlay.querySelector('.yt-player-trigger-play');
        this.iframeId = this.videoBlockEl.querySelector('iframe').getAttribute('id');
        this.player = null;
    }

    /**
      * Get YouTube ID from various YouTube URL
      * @author: takien
      * @url: http://takien.com
      * For PHP YouTube parser, go here http://takien.com/864
      * Tested URLs:
      var url = 'http://youtube.googleapis.com/v/4e_kz79tjb8?version=3';
      url = 'https://www.youtube.com/watch?feature=g-vrec&v=Y1xs_xPb46M';
      url = 'http://www.youtube.com/watch?feature=player_embedded&v=Ab25nviakcw#';
      url = 'http://youtu.be/Ab25nviakcw';
      url = 'http://www.youtube.com/watch?v=Ab25nviakcw';
      url = '<iframe width="420" height="315" src="http://www.youtube.com/embed/Ab25nviakcw" frameborder="0" allowfullscreen></iframe>';
      url = '<object width="420" height="315"><param name="movie" value="http://www.youtube-nocookie.com/v/Ab25nviakcw?version=3&amp;hl=en_US"></param><param name="allowFullScreen" value="true"></param><param name="allowscriptaccess" value="always"></param><embed src="http://www.youtube-nocookie.com/v/Ab25nviakcw?version=3&amp;hl=en_US" type="application/x-shockwave-flash" width="420" height="315" allowscriptaccess="always" allowfullscreen="true"></embed></object>';
      url = 'http://i1.ytimg.com/vi/Ab25nviakcw/default.jpg';
      url = 'https://www.youtube.com/watch?v=BGL22PTIOAM&feature=g-all-xit';
      url = 'BGL22PTIOAM';
      */
    YouTubeGetID (url) {
        let ID = '';
        url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        
        if(url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        } else {
            ID = url;
        }
        
        return ID;
    }

    checkThumbnail (width) {
        //HACK a mq thumbnail has width of 320.
        //if the video does not exist(therefore thumbnail don't exist), a default thumbnail of 120 width is returned.
        return !(width === 120);
    }

    setPlayer (player) {
        this.player = player;
    }

    onPlayerReady () {
        if (this.playButton) {
            this.playButton.addEventListener('click', this.handlePlayButtonClick.bind(this), true);
        }
    }

    handlePlayButtonClick (event) {
        event.preventDefault();
        event.stopPropagation();        

        this.playOverlay.classList.add('hidden');
        this.player.playVideo();
    }
}

class Videos {
    constructor () {
        this.players = [];
        this.queue = [];
    }

    add (video) {
        this.queue.push(video);
    }

    load () {
        window.onYouTubePlayerAPIReady = function() {
            this.queue.forEach(video => {
                const player = new YT.Player(video.iframeId, {
                    events: {
                        'onReady': video.onPlayerReady.bind(video)
                    }
                });
                video.setPlayer(player);
            })
        }.bind(this);
    }
}

const videoBlocks = document.querySelectorAll('.video-clip');
const videos = new Videos();

for (const videoBlock of videoBlocks) {
    const targetVideoId = '#' + videoBlock.getAttribute('id');
    const targetVideoObj = new Video(targetVideoId);
    targetVideoObj.init();
    videos.add(targetVideoObj);
}

// imported oldskl videos
const videoIframes = document.querySelectorAll('.oldskl .main-content iframe');
const regExp = new RegExp('^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$');

videoIframes.forEach((iframeEl, index) => {    
    if (!regExp.test(iframeEl.src)) {
        return;
    }

    const parentEl = iframeEl.parentNode;
    if (parentEl.nodeName !== 'DIV') {
        const iframeContainerEl = document.createElement('div');
        iframeContainerEl.classList.add('video-embed-frame');  
        iframeContainerEl.id = 'video-clip-' + index;      
        iframeContainerEl.setAttribute('data-video-counter', index);
        
        parentEl.replaceChild(iframeContainerEl, iframeEl);
        iframeContainerEl.appendChild(iframeEl);
    } else {
        parentEl.id = 'video-clip-' + index;
        parentEl.setAttribute('data-video-counter', index);
    }
    
    const targetVideoId = '#video-clip-' + index;
    const targetVideoObj = new Video(targetVideoId, true);
    targetVideoObj.init();
    videos.add(targetVideoObj);
});

videos.load();